import { useEffect, useRef, useState } from 'react'
import { motion, useInView } from 'framer-motion'
import styles from './ImpactMetric.module.css'

interface ImpactMetricProps {
  value: number
  label: string
  suffix?: string
  prefix?: string
  duration?: number
}

export default function ImpactMetric({ value, label, suffix = '', prefix = '', duration = 2 }: ImpactMetricProps) {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref, { once: true, margin: '-50px' })
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!isInView) return
    let start = 0
    const end = value
    const step = end / (duration * 60)
    const timer = setInterval(() => {
      start += step
      if (start >= end) {
        setCount(end)
        clearInterval(timer)
      } else {
        setCount(Math.floor(start))
      }
    }, 1000 / 60)
    return () => clearInterval(timer)
  }, [isInView, value, duration])

  const formatted = count >= 1000 ? count.toLocaleString() : count.toString()

  return (
    <motion.div
      ref={ref}
      className={styles.metric}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5 }}
    >
      <span className={styles.value}>
        {prefix}{formatted}{suffix}
      </span>
      <span className={styles.label}>{label}</span>
    </motion.div>
  )
}
